// Phones are stored as digits with country and area code (5547988881296) and shown with the mask
// +55 47 98888-1296. Up to 13 digits (DDI 2 + DDD 2 + 8 or 9).
export const PHONE_MAX_DIGITS = 13

export function phoneDigits(value: string | null | undefined): string {
  return (value ?? '').replace(/\D/g, '').slice(0, PHONE_MAX_DIGITS)
}

// Brazilian number written without the country code ("(47) 98888-1296") gets the 55 in front.
export function normalizePhone(value: string | null | undefined): string {
  const digits = (value ?? '').replace(/\D/g, '')
  return digits.length === 10 || digits.length === 11 ? `55${digits}` : digits.slice(0, PHONE_MAX_DIGITS)
}

// Mask while typing: +55 | +55 47 | +55 47 9888 | +55 47 9888-812 | +55 47 98888-1296.
export function maskPhone(value: string | null | undefined): string {
  const d = phoneDigits(value)
  if (!d) return ''
  const country = d.slice(0, 2)
  const area = d.slice(2, 4)
  const number = d.slice(4)
  const split = number.length > 8 ? 5 : 4
  const local = number.length > 4 ? `${number.slice(0, split)}-${number.slice(split)}` : number
  return ['+' + country, area, local].filter(Boolean).join(' ')
}

// Display of a stored phone: masked when complete, otherwise as it came.
export function formatPhone(value: string | null | undefined): string {
  const d = normalizePhone(value)
  return d.length >= 12 ? maskPhone(d) : value ?? ''
}
